import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {FormulaireService} from '../../../common/services/formulaire/formulaire.service';
import {from, Observable} from 'rxjs';
import {BlockTypeEnum, FormModel, FormState} from '../../../common/components/form/models';
import {AuthService, User} from '@Services/auth';
import {Individu, IndividuService} from '@Common/core/services';
import {SubSink} from '@Common/core/utils/subsink';
import {roles} from '../../../common/enum/roles';
import {start} from 'repl';
import {concatMap, finalize, tap} from 'rxjs/operators';

/**
 * Prévisualisation du formulaire
 * Entrée du formulaire :
 * - soit en querystring (id)
 * - soit en Input() formModel pour l'uuid
 */
@Component({
  selector: 'app-rendu-formulaire',
  templateUrl: './rendu-formulaire.component.html',
  styleUrls: ['./rendu-formulaire.component.scss']
})
export class RenduFormulaireComponent implements OnInit, OnDestroy {
  @Input() formModel;
  @Input() displayManagement = true;
  formModel$: Observable<FormModel>;
  user: User;
  individu: Individu;
  subSink = new SubSink();
  formState = FormState;
  blockType = BlockTypeEnum;
  submitted = false;
  loading = false;
  constructor(
    private auth: AuthService,
    private route: ActivatedRoute,
    private individuService: IndividuService,
    public formulaireSvc: FormulaireService) {
  }

  ngOnInit() {
    this.getFormById();
    this.subSink.sink = this.auth.userActivate$.subscribe(user => {
      if (user) {
        this.user = user;
      }
    });
    this.subSink.sink = this.individuService.individu$.subscribe(individu => this.individu = individu);
  }
  openLink(form: FormModel) {
    this.formulaireSvc.openModaleUrlForm(form);
  }
  widthForm() {
    return this.displayManagement ? '70' : '90';
  }
  hasAdministrativeBlock(form: FormModel) {
    return form?.blocks?.length > 0 &&
           form?.blocks?.find(_block => _block.type === BlockTypeEnum.Administratif) &&
           form?.blocks[0]?.fields_objs?.length > 0;
  }
  titlePath(form: FormModel) {
    let title = 'Visualisation du formulaire demandeur';
    if (this.hasAdministrativeBlock(form)) {
      title = `${title} et du suivi administratif`;
    }
    return title;
  }
  isGestionnaire() {
    return this.individu &&
      this.individuService.hasRole(this.individu, roles.gestionnaire) ||
      this.individuService.hasRole(this.individu, roles.superviseur) ||
      this.individuService.hasRole(this.individu, roles.admin);
  }
  getFormById() {
    this.loading = true;
    const param = this.route.snapshot.paramMap.get('id');
    let getForm;
    if (param) {
      getForm = this.formulaireSvc.get(param);
    } else {
      getForm = this.formulaireSvc.get(this.formModel.uuid);
    }
    this.formModel$ = getForm.pipe(finalize(() => this.loading = false));
  }
  ngOnDestroy() {
    this.subSink.unsubscribe();
  }
}
